/* BELVOIR&CO color taxonomy v3 — synchronized overlapping filter families.
   All groups initially collapsed, including on theme section re-renders.
   Group parent checkbox: select/deselect all + expand only that family.
   Arrow button: accordion only. Native storefront filter inputs are unchanged. */
(() => {
 if (window.__bvTaxonomyV3) return;
 window.__bvTaxonomyV3 = true;
 const rootSelector = '#filters-drawer .bv-color-taxonomy';
 const axisGroups = node => node.closest('.facets__filters-wrapper')?.querySelectorAll('.bv-color-taxonomy__group') || [];
 const byAxis = (group) => group.closest('.bv-color-taxonomy');
 function sameInputs(panel,value){
   return Array.from(panel.querySelectorAll('[data-bv-taxonomy-child]'))
     .filter(x => x.dataset.bvCanonical === value);
 }
 function updateParent(group){
   const children=Array.from(group.querySelectorAll('[data-bv-taxonomy-child]'));
   const parent=group.querySelector('[data-bv-taxonomy-parent]');
   if(!parent||!children.length)return;
   const n=children.filter(x=>x.checked).length;
   parent.checked=n===children.length;
   parent.indeterminate=n>0&&n<children.length;
   parent.setAttribute('aria-checked',parent.indeterminate?'mixed':String(parent.checked));
   const count=group.querySelector('[data-bv-taxonomy-partial]');
   if(count)count.textContent=n>0?n+'/'+children.length:'';
 }
 function syncPanel(panel){
   panel.querySelectorAll('.bv-color-taxonomy__group').forEach(updateParent);
 }
 function expand(group,opened){
   const panel=byAxis(group);
   const all=panel?.closest('.facets__filters-wrapper')?.querySelectorAll('.bv-color-taxonomy__group')||[];
   all.forEach(g=>{
     const yes=opened&&g===group;
     const content=g.querySelector('[data-bv-taxonomy-children]');
     const btn=g.querySelector('[data-bv-taxonomy-toggle]');
     if(content)content.hidden=!yes;
     if(btn)btn.setAttribute('aria-expanded',String(yes));
   });
 }
 function nativeChange(target){
   // Underlying collection/search controls retain their original form/name/value,
   // so the installed Horizon filter handler still sees the entire selected state.
   if(target)target.dispatchEvent(new Event('change',{bubbles:true}));
 }
 document.addEventListener('click',event=>{
   const target=event.target instanceof Element?event.target:null;
   if(!target)return;
   const arrow=target.closest('[data-bv-taxonomy-toggle]');
   if(!arrow)return;
   const group=arrow.closest('.bv-color-taxonomy__group');
   if(!group)return;
   event.preventDefault();
   event.stopPropagation();
   expand(group,arrow.getAttribute('aria-expanded')!=='true');
 },true);
 document.addEventListener('change',event=>{
   const target=event.target;
   if(!(target instanceof HTMLInputElement))return;
   const group=target.closest('.bv-color-taxonomy__group');
   const panel=group?.closest(rootSelector);
   if(!panel)return;
   if(target.matches('[data-bv-taxonomy-parent]')){
     event.stopPropagation();
     const selected=target.checked;
     const children=Array.from(group.querySelectorAll('[data-bv-taxonomy-child]'));
     for(const c of children){
       sameInputs(panel,c.dataset.bvCanonical).forEach(s=>{s.checked=selected;});
     }
     syncPanel(panel);
     expand(group,true);
     nativeChange(children[0]);
     return;
   }
   if(target.matches('[data-bv-taxonomy-child]')){
     // Keep the same actual color synchronized across overlapping families.
     sameInputs(panel,target.dataset.bvCanonical).forEach(s=>{s.checked=target.checked;});
     syncPanel(panel);
   }
 },true);
 const observer=new MutationObserver(records=>{
   for(const record of records){
     if(record.type!=='childList')continue;
     for(const node of record.addedNodes){
       if(!(node instanceof Element))continue;
       if(node.matches(rootSelector)||node.querySelector(rootSelector)){
         node.querySelectorAll?.(rootSelector).forEach(panel=>syncPanel(panel));
       }
     }
   }
 });
 document.addEventListener('DOMContentLoaded',()=>{
   document.querySelectorAll(rootSelector).forEach(panel=>syncPanel(panel));
   observer.observe(document.body,{childList:true,subtree:true});
 },{once:true});
})();
